import datacentral from '@/utils/axios/datacentral'
import { ResponseObject } from '@/types/shared'
import {
    AwaitingRatingFilters,
    AwaitingRatingItem,
    InternalRating,
    PagedRatings,
    PagedResult,
    ReceivedRatingFilters,
    SubmitRatingPayload,
    TicketRatingView,
} from '../types'

// buildQuery: bỏ field rỗng/undefined và encodeURIComponent mọi giá trị — filter là
// input người dùng nên có thể chứa '&', '%', '='; nội suy thô sẽ làm hỏng query string.
const buildQuery = (params: Record<string, unknown>) =>
    Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(
            ([k, v]) =>
                `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`
        )
        .join('&')

// BE-3: rating hiện có của tôi + context (eligible/terminal/already_rated/rated_departments).
export const getTicketRatingView = async (ticketId: number) => {
    const res = await datacentral.get<ResponseObject<TicketRatingView>>(
        `tickets/${ticketId}/internal-ratings`
    )
    return res.data.result
}

// Submit chấm sao cho 1 ticket (rater = người tạo request).
export const submitTicketRating = async (
    ticketId: number,
    payload: SubmitRatingPayload
) => {
    const res = await datacentral.post<ResponseObject<InternalRating>>(
        `tickets/${ticketId}/internal-ratings`,
        payload
    )
    return res.data.result
}

// BE-2: đánh giá tôi nhận được (kèm tên người chấm), phân trang + summary tổng quan.
// summary luôn tính trên TOÀN BỘ đánh giá, KHÔNG theo filter — nó là "điểm của tôi",
// không phải "điểm của kết quả đang lọc".
export const getMyReceivedRatings = async (
    page: number,
    pageSize: number,
    filters: ReceivedRatingFilters = {}
) => {
    const res = await datacentral.get<ResponseObject<PagedRatings>>(
        `ratings/my-received?${buildQuery({
            page,
            page_size: pageSize,
            ...filters,
        })}`
    )
    return res.data.result
}

// BE-1: ticket service terminal do tôi tạo, chưa chấm (tab "Chờ tôi đánh giá").
export const getAwaitingRatings = async (
    page: number,
    pageSize: number,
    filters: AwaitingRatingFilters = {}
) => {
    const res = await datacentral.get<
        ResponseObject<PagedResult<AwaitingRatingItem>>
    >(
        `ratings/awaiting?${buildQuery({
            page,
            page_size: pageSize,
            ...filters,
        })}`
    )
    return res.data.result
}
